import { IconButton } from './Button';
import { useSettings } from './SettingsContext';
import './SettingsBar.css';

/* ============================================================================
   SettingsBar — the sound and CRT-intensity toggles.

   Two buttons, no menu: Discord's Electron client swallows most keyboard
   shortcuts before they reach the activity iframe, so anything the player
   needs to reach has to be a visible control.
   ========================================================================== */

const FX_ICON = { full: '📺', low: '📻', off: '⬛' };
const FX_TITLE = {
  full: 'Effects: full CRT',
  low: 'Effects: reduced',
  off: 'Effects: off',
};

function SettingsBar({ className = '' }) {
  const { fx, sound, cycleFx, toggleSound } = useSettings();

  return (
    <div className={`ui-settings-bar ${className}`}>
      <IconButton
        label={sound ? 'Sound on — click to mute' : 'Sound off — click to unmute'}
        active={sound}
        onClick={toggleSound}
        // The toggle plays its own confirmation from inside the state update,
        // where the AudioContext can still resume off this click's gesture.
        sound={null}
      >
        {sound ? '🔊' : '🔇'}
      </IconButton>

      <IconButton
        label={FX_TITLE[fx]}
        active={fx !== 'off'}
        onClick={cycleFx}
      >
        {FX_ICON[fx]}
      </IconButton>
    </div>
  );
}

export default SettingsBar;
